module.exports = __webpack_public_path__ + "img/social-recruitment1.6eae24e0.svg";